<template>
    <div class="max-w-screen-xl mx-auto flex justify-center py-20">
        <div class="mx-auto sm:px-7 px-4 dark:text-white max-w-screen-xl">
            <h4 class="text-center text-3xl lg:text-4xl font-medium">Subscribe to Updates</h4>
            <form>
                <div class="grid items-center gap-4 mt-6 sm:grid-flow-col auto-cols-max">
                    <input type="text" autocomplete="email" required placeholder="Enter your email"
                        class="p-3 transition border-none w-72 sm:w-84 md:p-4 lg:p-4 lg:text-lg sm:mx-0 bg-gray-100 placeholder-gray-400 text-grow focus:outline-none focus:ring-2 focus:ring-grow rounded-xl"
                        value="">
                    <button type="submit"
                        class="w-full sm:w-48 sm:mx-0 sm:h-full text-lg  h-11 px-5 font-semibold bg-success hover:bg-teal-9 text-white focus-visible:shadow-button-focus-success  whitespace-nowrap tracking-[-0.01em] transition focus:outline-none inline-flex items-center justify-center rounded-full">Subscribe</button>
                </div>
            </form>
        </div>
    </div>
</template>